import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Menu = ({ cat }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `https://asher-blog.onrender.com/api/posts/?cat=${cat}`
        );
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [cat]);

  //Define your default image URL
  const defaultImg = "../upload/404_1.png"; // Replace with the actual path

  return (
    <div className="menu">
      <h1>Other posts you may like</h1>
      {posts.map((post) => (
        <div className="post" key={post.id}>
          <img
            src={`../upload/${post.img}`}
            alt=""
            onError={(e) => {
              // Set the src attribute to the default image URL on error
              e.target.src = defaultImg;
            }}
          />
          <h2>{post.title}</h2>

          <Link to={`/post/${post.id}`}>
            <button>Read More</button>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Menu;
